import Container from "react-bootstrap/Container";

import Faq from "@/components/help/faq/promoted";
import Sections from "../sections";
import Head from "@/components/head";
import Translate from "@/components/base/translate";

import styles from "./Page.module.css";
import React from "react";

/**
 * The Articles page React component
 *
 * @returns {React.JSX.Element}
 *
 */

export default function Page() {
  const context = { context: "metadata" };

  const pageTitle = Translate({
    ...context,
    label: "help-title",
  });

  const pageDescription = Translate({
    ...context,
    label: "help-description",
  });

  return (
    <React.Fragment>
      <Head title={pageTitle} description={pageDescription} />
      <main>
        <Container className={styles.top} fluid>
          <Faq className={styles.faq} />
          <Sections />
        </Container>
      </main>
    </React.Fragment>
  );
}
